import { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import ProtectedRoutesAuth from "@/pages/routes/ProtectedRoutesAuth";
import { loggedInRoutes } from "@/routes/loggedInRoutes/index";
import ProtectedRoutesProfile from "@/pages/routes/ProtectedRoutesProfile";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { PageDoesntExist } from "@/pageDoesntExist";
import ErrorRoutes from "@/pages/routes/ErrorRoutes";
import {
  CreateUsernameAndProfile,
  ForgotPassword,
  Login,
  PasswordReset,
  Signup,
  VerifyEmail,
} from "@/features/auth";
import { siteRoutes } from "@/routes/siteRoutesList";
import { EventQrCode } from "@/features/auth/pages/eventQrSignUp/EventsQr";
import { ScannedQR } from "@/features/auth/pages/eventQrSignUp/ScannedQR";
import { SpaceCoinsRedirect } from "branchAndBrandSpecific/features/space-coins-redirect/spaceCoins.redirect";
import { TreasureHuntRedirect } from "branchAndBrandSpecific/features/treasure-hunt/TreasureHuntRedirect";
import { Challenge1337Redirect } from "branchAndBrandSpecific/features/1337-challenge/1337.challenge.redirect";
import { MultiplayerBrowserGameRedirect } from "branchAndBrandSpecific/features/join-multiplayer-game-redirect/multiplayer-game.redirect";
import { Challenge1337Pagelarge } from "branchAndBrandSpecific/features/1337-challenge/1337.challenge.page.large";
import { AuthDiscordRedirect } from "@/features/auth/pages/authRedirects/auth.discord.redirect";
import { AuthTwitchRedirect } from "@/features/auth/pages/authRedirects/auth.twitch.redirect";
import { ContactForm1337 } from "@/features/forms/1337-contact-form/1337.contact.form";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy/PrivacyPolicy";
import { TermsOfUse } from "@/pages/TermsOfUse/TermsOfUse";
import PrecisionGameVertical from "@/pages/PrecisionGame/PrecisionGameVertical";
import { SignUpAnonymouslyUrl } from "@/features/auth/components/SignUpAnonymouslyUrl";
import PrecisionGamePS5Signup from "@/pages/PrecisionGame/PrecisionGame.PS5.signup";
import { AutoVerifyEmailRedirect } from "@/features/auth/pages/authRedirects/auth.verifyEmail.redirect";

const isElgiganten = brand.brandValue === "ELGIGANTEN";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedRoutesAuth />, //for sign-up-1
    errorElement: <ErrorRoutes />,
    children: [
      {
        path: "/landing",
        element: <Login />,
        errorElement: <ErrorRoutes />,
      },
      {
        path: "/signincallback/",
        element: <PageDoesntExist />, //for landing page
        errorElement: <ErrorRoutes />,
      },
      {
        path: "/",
        element: <Login />,
        errorElement: <ErrorRoutes />,
      },
      {
        path: siteRoutes["quickAccount"],
        element: <SignUpAnonymouslyUrl />,
        errorElement: <ErrorRoutes />,
      },
      {
        path: siteRoutes["PSRedirect"],
        element: <PrecisionGamePS5Signup />,
        errorElement: <ErrorRoutes />,
      },

      // Auth
      {
        path: "/verify-email/:email/:code",
        element: <AutoVerifyEmailRedirect />,
        errorElement: <ErrorRoutes />,
      },
      {
        path: "/discord-auth",
        element: <AuthDiscordRedirect />, //for landing page
        errorElement: <ErrorRoutes />,
      },
      {
        path: "/twitch-auth",
        element: <AuthTwitchRedirect />, //for landing page
        errorElement: <ErrorRoutes />,
      },
      //
      {
        path: "/login",
        element: <Login />, //for landing page
        errorElement: <ErrorRoutes />,
      },
      {
        path: `/signup/:slug`,
        element: brand.hasFeature.landing ? <Signup /> : <PageDoesntExist />, //for landing page
        errorElement: <ErrorRoutes />,
      },
      {
        path: "/signup",
        element: brand.hasFeature.landing ? <Signup /> : <PageDoesntExist />, //for landing page
        errorElement: <ErrorRoutes />,
      },
      {
        path: "/verify-email",
        element: <VerifyEmail />,
        errorElement: <ErrorRoutes />,
      },
      {
        path: "/enter-username",
        element: <CreateUsernameAndProfile />,
        errorElement: <ErrorRoutes />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
        errorElement: <ErrorRoutes />,
      },
      {
        path: "/password-reset",
        element: <PasswordReset />,
        errorElement: <ErrorRoutes />,
      },
      {
        path: siteRoutes["terms"],
        element: <TermsOfUse />,
        errorElement: <ErrorRoutes />,
      },
      {
        path: siteRoutes["privacy-policy"],
        element: <PrivacyPolicy />,
        errorElement: <ErrorRoutes />,
      },
      {
        element: <EventQrCode />,
        path: siteRoutes["eventQrCode"],
      },
      {
        element: <ScannedQR />,
        path: `${siteRoutes["scanQrCodeAndSlug"]}:pcId`,
      },
      {
        element: <ContactForm1337 />,
        path: siteRoutes["contactForm1337"],
      },
      {
        element: isElgiganten ? (
          <Challenge1337Pagelarge />
        ) : (
          <PageDoesntExist />
        ),
        path: siteRoutes["leet-lg"],
      },
      {
        element: brand.hasFeature.precisionGame ? (
          <PrecisionGameVertical />
        ) : (
          <PageDoesntExist />
        ),
        path: siteRoutes["leet-vertical"],
      },

      {
        element: brand.hasFeature.treasure_hunt ? (
          <TreasureHuntRedirect />
        ) : (
          <PageDoesntExist />
        ),
        path: siteRoutes["treasureHuntRedirect"],
      },
      {
        element: isElgiganten ? <Challenge1337Redirect /> : <PageDoesntExist />,
        path: siteRoutes["leet-redirect"],
      },
      {
        element: brand.hasFeature.treasure_hunt ? (
          <TreasureHuntRedirect />
        ) : (
          <PageDoesntExist />
        ),
        path: `${siteRoutes["treasureHuntRedirect"]}:thid`,
      },
      {
        element: brand.event.spacecoins_redirect ? (
          <SpaceCoinsRedirect />
        ) : (
          <PageDoesntExist />
        ),
        path: siteRoutes["spacecoins_redirect"],
      },

      {
        element: brand.event.spacecoins_redirect ? (
          <MultiplayerBrowserGameRedirect />
        ) : (
          <PageDoesntExist />
        ),
        path: siteRoutes["multiplayerBrowserGame_redirect"],
      },
      {
        path: "/",
        element: <ProtectedRoutesProfile />, // for sign-up-2
        errorElement: <ErrorRoutes />,
        children: loggedInRoutes.map((route) => {
          const Element = route.element;
          const Fallback = FallBackLoader;
          return {
            path: route.path,
            element: (
              <Suspense fallback={<Fallback />}>
                <Element />
              </Suspense>
            ),
          };
        }),
      },
    ],
  },
]);

function FallBackLoader() {
  return <h1>fallback...</h1>;
}
